import {
  Box,
  Breadcrumbs,
  CircularProgress,
  Grid,
  Pagination,
  PaginationItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Colors from "../../components/constants/Colors";
import { FilterCadastroFornecedor } from "../../components/filter/FilterCadastroFornecedor";
import CustomDatagrid from "../../components/datagrid/CustomDatagrid";
import { Add, ArrowBack, NavigateNext, PostAdd } from "@mui/icons-material";
import { headers } from "../../components/core/store/localStorage";
import axios from "axios";
import errorHandler from "../../components/core/store/errorHandler";
import {
  formatMulta,
  isEmailValid,
  isValidCNPJ,
  isValidCPF,
} from "../../helpers/formaters";
import { usePaginationQuery } from "../../helpers/pagination";
import ErrorModal from "../../components/modals/ErrorModal";
import { ConfirmModal } from "../../components/modals/ConfirmModal";

const currentUser = sessionStorage.getItem("userName");
const currentEmp = sessionStorage.getItem("empName");
const API_URL = sessionStorage.getItem("apiUrl");
const PAGE_SIZE = 30;

export const ContasAPagarFornecedor = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { setQueryParams } = usePaginationQuery();

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const page = Number(query.get("page") || 1);
  const filter = query.get("filtro");
  const isMobile = useMediaQuery("(max-width: 375px)");

  const [head, setHead] = useState([]);
  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({});
  const [totalPages, setTotalPages] = useState(0);

  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [titleLoading, setTitleLoading] = useState("Carregando...");
  const [searchValue, setSearchValue] = useState("");
  const [showGrid, setShowGrid] = useState(false);
  const [isSearch, setIsSearch] = useState(true);

  const [codFornec, setCodFornec] = useState("");
  const [cnpjCpf, setCnpjCpf] = useState("");
  const [razaoSocial, setRazaoSocial] = useState("");
  const [tipoFornec, setTipoFornec] = useState("");
  const [tipoFornecList, setTipoFornecList] = useState([]);
  const [exterior, setExterior] = useState(false);
  const [nomeFantasia, setNomeFantasia] = useState("");
  const [sigla, setSigla] = useState("");
  const [contato, setContato] = useState("");
  const [celular, setCelular] = useState("");
  const [representante, setRepresentante] = useState("");
  const [representanteList, setRepresentanteList] = useState([]);
  const [cep, setCep] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");
  const [codigoCidade, setCodigoCidade] = useState("");
  const [cidade, setCidade] = useState("");
  const [codigoPais, setCodigoPais] = useState("");
  const [pais, setPais] = useState("");
  const [estado, setEstado] = useState("");
  const [estadoList, setEstadoList] = useState([]);
  const [telefone1, setTelefone1] = useState("");
  const [telefone2, setTelefone2] = useState("");
  const [fax, setFax] = useState("");
  const [agenteFinanceiro, setAgenteFinanceiro] = useState("");
  const [agenteFinanceiroList, setAgenteFinanceiroList] = useState([]);
  const [agencia, setAgencia] = useState("");
  const [agenciaList, setAgenciaList] = useState([]);
  const [corrente, setCorrente] = useState("");
  const [correnteList, setCorrenteList] = useState([]);
  const [inscricaoEstadual, setInscricaoEstadual] = useState("");
  const [email, setEmail] = useState("");
  const [icms, setIcms] = useState("");
  const [pkPadrao, setPkPadrao] = useState("");
  const [centroCusto, setCentroCusto] = useState("");
  const [centroCustoList, setCentroCustoList] = useState([]);
  const [despesa, setDespesa] = useState("");
  const [despesaList, setDespesaList] = useState([]);
  const [contaContabil, setContaContabil] = useState("");
  const [planoContasList, setPlanoContasList] = useState([]);
  const [isentoIcms, setIsentoIcms] = useState("");
  const [aceitaDevolucao, setAceitaDevolucao] = useState("");
  const [fabricante, setFabricante] = useState("");
  const [frete, setFrete] = useState("");
  const [inativo, setInativo] = useState(false);

  const [hasSearched, setHasSearched] = useState(false);
  const [openPayloadModal, setOpenPayloadModal] = useState(false);
  const [payloadErrors, setPayloadErrors] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openBackModal, setOpenBackModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [messageModal, setMessageModal] = useState("");
  const [openMessageModal, setOpenMessageModal] = useState(false);

  const [errors, setErrors] = useState({});
  const cnpjCpfRef = useRef(null);
  const razaoSocialRef = useRef(null);
  const tipoFornecRef = useRef(null);
  const nomeFantasiaRef = useRef(null);
  const siglaRef = useRef(null);
  const contatoRef = useRef(null);
  const telefone1Ref = useRef(null);
  const cepRef = useRef(null);
  const logradouroRef = useRef(null);
  const numeroRef = useRef(null);
  const bairroRef = useRef(null);
  const estadoRef = useRef(null);
  const codigoCidadeRef = useRef(null);
  const cidadeRef = useRef(null);
  const codigoPaisRef = useRef(null);
  const paisRef = useRef(null);

  useEffect(() => {
    if (API_URL === null) window.location.href = "/";
    getTipoFornec();
    getCentroCusto();
    getDespesa();
    getPlanoContas();
  }, []);

  useEffect(() => {
    if (!hasSearched) return;
    fetchFornecedor(page, filter);
  }, [page, filter, hasSearched]);

  const getTipoFornec = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/tipofornecedor/combo`,
        headers(),
      );

      setTipoFornecList(response.data.tipofornecedor || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const tipoFornecListAtivos = useMemo(
    () => (tipoFornecList || []).filter((item) => item.inativo === false),
    [tipoFornecList],
  );

  const getCentroCusto = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/centrocusto/combo`,
        headers(),
      );

      setCentroCustoList(response.data.centrocusto || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const centroCustoListAtivos = useMemo(
    () => (centroCustoList || []).filter((item) => item.inativo === false),
    [centroCustoList],
  );

  const getDespesa = async () => {
    try {
      const response = await axios.get(`${API_URL}/despesa/combo`, headers());

      setDespesaList(response.data.despesa || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const despesaListAtivos = useMemo(
    () => (despesaList || []).filter((item) => item.inativo === false),
    [despesaList],
  );

  const getPlanoContas = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/planocontas/combo`,
        headers(),
      );

      setPlanoContasList(response.data.planocontas || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const planoContasListAtivos = useMemo(
    () => (planoContasList || []).filter((item) => item.inativo === false),
    [planoContasList],
  );

  const fetchFornecedor = async (pageToFetch) => {
    setLoading(true);
    setShowGrid(false);
    setNotFound(false);

    try {
      const url = searchValue?.trim()
        ? `${API_URL}/fornecedor?page=${pageToFetch}&filtro=${encodeURIComponent(
            searchValue.trim(),
          )}`
        : `${API_URL}/fornecedor?page=${pageToFetch}`;

      const response = await axios.get(url, headers());

      const payload = response?.data || {};

      const data = payload.data || [];
      const pages = Number(payload.totalPages || 1);

      setTotalPages(pages);

      if (pageToFetch > pages) {
        setQueryParams({ page: pages }, true);
        return;
      }

      if (data.length === 0) {
        setNotFound(true);
        setShowGrid(false);
        if (pageToFetch > 1) setQueryParams({ page: 1 }, true);
        return;
      }

      setShowGrid(true);
      setHead(payload.columns || []);
      setRows(data);
      setTotals(payload.totalizador || {});
      setNotFound(false);
    } catch (error) {
      setShowGrid(false);
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (row) => {
    setInativo(row.inativo === "Cancelado" ? true : false);
    setErrors({});
    setIsSearch(false);
    setCnpjCpf(row.id);
    setRazaoSocial(row.name);
    setTipoFornec(row.content.tipoFornecId);
    setExterior(row.content.exterior);
    setNomeFantasia(row.content.nomeFantasia);
    setSigla(row.content.sigla);
    setContato(row.content.contato);
    setCelular(row.content.celular);
    setRepresentante(row.content.representante);
    setCep(row.content.cep);
    setLogradouro(row.content.logradouro);
    setNumero(row.content.numero);
    setComplemento(row.content.complemento);
    setBairro(row.content.bairro);
    setCodigoCidade(row.content.codigoCidade);
    setCidade(row.content.cidade);
    setCodigoPais(row.content.codigoPais);
    setPais(row.content.pais);
    setEstado(row.content.estado);
    setTelefone1(row.content.telefone1);
    setTelefone2(row.content.telefone2);
    setFax(row.content.fax);
    setAgenteFinanceiro(row.content.agenteFinanceiro);
    setAgencia(row.content.agencia);
    setCorrente(row.content.corrente);
    setInscricaoEstadual(row.content.inscricaoEstadual);
    setEmail(row.content.email);
    setIcms(formatMulta(row.content.icms));
    setPkPadrao(row.content.pkPadrao);
    setCentroCusto(row.content.centroCustoId);
    setDespesa(row.content.despesaId);
    setContaContabil(row.content.contaContabil);
    setIsentoIcms(row.content.isentoIcms);
    setAceitaDevolucao(row.content.aceitaDevolucao);
    setFabricante(row.content.fabricante);
    setFrete(row.content.frete);
    setShowGrid(false);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setOpenMessageModal(true);

    const pergunta =
      row.inativo === "Cancelado"
        ? "Deseja realmente ativar este fornecedor?"
        : "Deseja realmente desativar este fornecedor?";

    setMessageModal(pergunta);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    setShowGrid(false);

    let novoStatusInativo;
    selectedRow.inativo === "Cancelado"
      ? (novoStatusInativo = false)
      : (novoStatusInativo = true);

    const payload = {
      ...selectedRow.content,
      inativo: novoStatusInativo,
    };

    // console.log(payload);

    try {
      await axios.post(`${API_URL}/fornecedor`, payload, headers());
      fetchFornecedor(page);
    } catch (err) {
      errorHandler(err);
      if (err.response?.data?.message) {
        setPayloadErrors([err.response.data.message]);
        setOpenPayloadModal(true);
      }
    } finally {
      setLoading(false);
      setShowGrid(true);
      setOpenMessageModal(false);
    }
  };

  const searchFornec = () => {
    setHasSearched(true);
    setQueryParams({ page: 1, filtro: searchValue }, false);
  };

  const newFornec = async () => {
    setInativo(false);
    setLoading(false);
    setIsSearch(false);
    setNotFound(false);
    setShowGrid(false);
    setTipoFornec("");
    setSearchValue("");
    setHasSearched(false);
    setTotalPages(0);
    setRows([]);
    setHead([]);
    clearFields();
  };

  const handleBack = () => {
    setOpenBackModal(true);
  };

  const confirmBack = () => {
    clearFields();
    setLoading(false);
    setNotFound(false);
    setHasSearched(false);
    setIsSearch(true);
    setOpenBackModal(false);
  };

  const handleChangeCentroCusto = async (e) => {
    const centroCustoId = e.target.value;
    setCentroCusto(centroCustoId);

    try {
      const response = await axios.get(
        `${API_URL}/despesa/combo?centroCustoId=${centroCustoId}`,
        headers(),
      );

      setDespesaList(response.data.despesa || []);
    } catch (error) {
      errorHandler(error);
      setDespesaList([]);
    }
  };

  const handleChangeDespesa = async (e) => {
    const despesaId = e.target.value;
    setDespesa(despesaId);

    try {
      const response = await axios.get(
        `${API_URL}/centrocusto/combo?despesaId=${despesaId}`,
        headers(),
      );

      setCentroCustoList(response.data.centrocusto || []);
    } catch (error) {
      errorHandler(error);
      setCentroCustoList([]);
    }
  };

  const focusRef = (ref) => ref?.current?.focus?.();

  const cadFornec = async () => {
    const required = (cond, msg, fieldName, ref) => {
      if (cond) return false;

      setPayloadErrors(Array.isArray(msg) ? msg : [msg]);
      setOpenPayloadModal(true);
      setErrors((prev) => ({ ...prev, [fieldName]: true }));

      focusRef(ref);

      return true;
    };

    const cleanValue = (cnpjCpf || "").replace(/\D/g, "");

    if (
      required(
        cleanValue.length > 0,
        "Documento é obrigatório.",
        "cnpjCpf",
        cnpjCpfRef,
      )
    )
      return;

    if (cleanValue.length === 11) {
      if (
        required(
          isValidCPF(cleanValue),
          "O CPF informado é inválido.",
          "cnpjCpf",
          cnpjCpfRef,
        )
      )
        return;
    } else if (cleanValue.length === 14) {
      if (
        required(
          isValidCNPJ(cleanValue),
          "O CNPJ informado é inválido.",
          "cnpjCpf",
          cnpjCpfRef,
        )
      )
        return;
    } else {
      if (
        required(
          false,
          "Documento inválido. Informe um CPF ou CNPJ completo.",
          "cnpjCpf",
          cnpjCpfRef,
        )
      )
        return;
    }

    if (
      required(
        !!razaoSocial?.trim(),
        "Razão social deve ser preenchida.",
        "razaoSocial",
        razaoSocialRef,
      )
    )
      return;

    if (
      required(
        !!tipoFornec?.trim(),
        "Tipo de fornecedor deve ser selecionado.",
        "tipoFornec",
        tipoFornecRef,
      )
    )
      return;

    if (
      required(
        !!nomeFantasia?.trim(),
        "Nome fantasia deve ser preenchido.",
        "nomeFantasia",
        nomeFantasiaRef,
      )
    )
      return;

    if (
      required(!!sigla?.trim(), "Sigla deve ser preenchida.", "sigla", siglaRef)
    )
      return;
    if (
      required(
        !!contato?.trim(),
        "Contato deve ser preenchido.",
        "contato",
        contatoRef,
      )
    )
      return;
    if (
      required(
        !!telefone1?.trim(),
        "Telefone 1 deve ser preenchido.",
        "telefone1",
        telefone1Ref,
      )
    )
      return;

    if (required(!!cep?.trim(), "CEP deve ser preenchido.", "cep", cepRef))
      return;
    if (
      required(
        !!logradouro?.trim(),
        "Logradouro deve ser preenchido.",
        "logradouro",
        logradouroRef,
      )
    )
      return;
    if (
      required(
        !!numero?.trim(),
        "Número deve ser preenchido.",
        "numero",
        numeroRef,
      )
    )
      return;
    if (
      required(
        !!bairro?.trim(),
        "Bairro deve ser preenchido.",
        "bairro",
        bairroRef,
      )
    )
      return;

    if (
      required(
        !!codigoCidade?.toString().trim(),
        "Código da cidade deve ser preenchido.",
        "codigoCidade",
        codigoCidadeRef,
      )
    )
      return;

    if (
      required(
        !!cidade?.trim(),
        "Cidade deve ser preenchida.",
        "cidade",
        cidadeRef,
      )
    )
      return;
    if (
      required(
        !!estado?.trim(),
        "Estado deve ser preenchido.",
        "estado",
        estadoRef,
      )
    )
      return;
    if (required(!!pais?.trim(), "País deve ser preenchido.", "pais", paisRef))
      return;

    setOpenConfirmModal(true);
  };

  const handleConfirmSave = async () => {
    setOpenConfirmModal(false);
    setLoading(true);

    const payload = {
      id: cnpjCpf.trim(),
      cnpjCpf: cnpjCpf.trim(),
      name: razaoSocial.trim(),
      tipoFornecId: tipoFornec,
      exterior,
      nomeFantasia: nomeFantasia.trim(),
      sigla: sigla.trim(),
      contato: contato.trim(),
      celular: celular.trim(),
      telefone1: telefone1.trim(),
      telefone2: telefone2.trim(),
      fax: fax.trim(),
      // representante: representante.trim(),
      cep: cep.trim(),
      logradouro: logradouro.trim(),
      numero: numero.toString().trim(),
      complemento: complemento.trim(),
      bairro: bairro.trim(),
      estado,
      codigoCidade: codigoCidade.toString().trim(),
      cidade: cidade.trim(),
      codigoPais: codigoPais.toString().trim(),
      pais: pais.trim(),
      // agenteFinanceiro: agenteFinanceiro.trim(),
      // agencia: agencia.trim(),
      // corrente: corrente.trim(),
      inscricaoEstadual: inscricaoEstadual.trim(),
      email: email.trim(),
      icms: icms.trim(),
      pkPadrao: pkPadrao.trim(),
      centroCustoId: centroCusto,
      despesaId: despesa,
      contaContabil,
      isentoIcms,
      aceitaDevolucao,
      fabricante,
      frete,
      inativo,
    };

    try {
      const response = await axios.post(
        `${API_URL}/fornecedor`,
        payload,
        headers(),
      );

      setLoading(false);
      setNotFound(false);
      setIsSearch(true);
      setHasSearched(false);
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const clearFields = () => {
    setErrors({});
    setCodFornec("");
    setCnpjCpf("");
    setRazaoSocial("");
    setTipoFornec("");
    setExterior(false);
    setNomeFantasia("");
    setSigla("");
    setContato("");
    setCelular("");
    setRepresentante("");
    setCep("");
    setLogradouro("");
    setNumero("");
    setComplemento("");
    setBairro("");
    setCodigoCidade("2304400");
    setCidade("Fortaleza");
    setCodigoPais("1058");
    setPais("Brasil");
    setEstado("");
    setTelefone1("");
    setTelefone2("");
    setFax("");
    setAgenteFinanceiro("");
    setAgencia("");
    setCorrente("");
    setInscricaoEstadual("");
    setEmail("");
    setIcms("");
    setPkPadrao("");
    setCentroCusto("");
    setDespesa("");
    setContaContabil("");
    setIsentoIcms("");
    setAceitaDevolucao("");
    setFabricante("");
    setFrete("");
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid wrap="wrap">
          <Grid
            size={{ xs: 6, sm: 7, md: 8, xl: 10 }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Breadcrumbs
                separator={<NavigateNext fontSize="small" />}
                aria-label="breadcrumb"
              >
                <Typography
                  className={css(styles.pageTitle)}
                  sx={{ fontWeight: 400, color: "#828282" }}
                >
                  Contas a Pagar
                </Typography>
                <Typography className={css(styles.pageTitle)}>
                  Cadastros
                </Typography>
                <Typography className={css(styles.pageTitle)}>
                  Fornecedores
                </Typography>
              </Breadcrumbs>
            </div>
            <div style={{ display: "flex", gap: "5px" }}>
              {isSearch && (
                <button
                  onClick={newFornec}
                  className={css(styles.topBtn)}
                  title="Inclui"
                >
                  <PostAdd style={{ fontSize: "1.4rem" }} />
                </button>
              )}
              {!isSearch && (
                <button
                  onClick={handleBack}
                  className={css(styles.topBtn)}
                  title="Voltar"
                >
                  <ArrowBack style={{ fontSize: "1.4rem" }} />
                </button>
              )}
            </div>
          </Grid>
        </Grid>

        <hr
          style={{
            color: "#eee",
            // marginTop: "-0.55rem",
            marginBottom: "0.75rem",
          }}
        />

        <Box
          sx={{
            maxWidth: 1200,
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <FilterCadastroFornecedor
            tipoFornecListAtivos={tipoFornecListAtivos}
            centroCustoListAtivos={centroCustoListAtivos}
            despesaListAtivos={despesaListAtivos}
            planoContasListAtivos={planoContasListAtivos}
            errors={errors}
            setErrors={setErrors}
            cnpjCpfRef={cnpjCpfRef}
            razaoSocialRef={razaoSocialRef}
            tipoFornecRef={tipoFornecRef}
            nomeFantasiaRef={nomeFantasiaRef}
            siglaRef={siglaRef}
            contatoRef={contatoRef}
            telefone1Ref={telefone1Ref}
            cepRef={cepRef}
            logradouroRef={logradouroRef}
            numeroRef={numeroRef}
            bairroRef={bairroRef}
            estadoRef={estadoRef}
            codigoCidadeRef={codigoCidadeRef}
            cidadeRef={cidadeRef}
            codigoPaisRef={codigoPaisRef}
            paisRef={paisRef}
            handleChangeCentroCusto={handleChangeCentroCusto}
            handleChangeDespesa={handleChangeDespesa}
            handleBack={handleBack}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            searchFornec={searchFornec}
            isSearch={isSearch}
            planoContasList={planoContasList}
            codFornec={codFornec}
            setCodFornec={setCodFornec}
            cadFornec={cadFornec}
            cnpjCpf={cnpjCpf}
            setCnpjCpf={setCnpjCpf}
            razaoSocial={razaoSocial}
            setRazaoSocial={setRazaoSocial}
            tipoFornec={tipoFornec}
            setTipoFornec={setTipoFornec}
            tipoFornecList={tipoFornecList}
            exterior={exterior}
            setExterior={setExterior}
            nomeFantasia={nomeFantasia}
            setNomeFantasia={setNomeFantasia}
            sigla={sigla}
            setSigla={setSigla}
            contato={contato}
            setContato={setContato}
            celular={celular}
            setCelular={setCelular}
            representante={representante}
            setRepresentante={setRepresentante}
            representanteList={representanteList}
            cep={cep}
            setCep={setCep}
            logradouro={logradouro}
            setLogradouro={setLogradouro}
            numero={numero}
            setNumero={setNumero}
            complemento={complemento}
            setComplemento={setComplemento}
            bairro={bairro}
            setBairro={setBairro}
            codigoCidade={codigoCidade}
            setCodigoCidade={setCodigoCidade}
            cidade={cidade}
            setCidade={setCidade}
            codigoPais={codigoPais}
            setCodigoPais={setCodigoPais}
            pais={pais}
            setPais={setPais}
            estado={estado}
            setEstado={setEstado}
            estadoList={estadoList}
            telefone1={telefone1}
            setTelefone1={setTelefone1}
            telefone2={telefone2}
            setTelefone2={setTelefone2}
            fax={fax}
            setFax={setFax}
            agenteFinanceiro={agenteFinanceiro}
            setAgenteFinanceiro={setAgenteFinanceiro}
            agenteFinanceiroList={agenteFinanceiroList}
            agencia={agencia}
            setAgencia={setAgencia}
            agenciaList={agenciaList}
            corrente={corrente}
            setCorrente={setCorrente}
            correnteList={correnteList}
            inscricaoEstadual={inscricaoEstadual}
            setInscricaoEstadual={setInscricaoEstadual}
            email={email}
            setEmail={setEmail}
            icms={icms}
            setIcms={setIcms}
            pkPadrao={pkPadrao}
            setPkPadrao={setPkPadrao}
            centroCusto={centroCusto}
            setCentroCusto={setCentroCusto}
            centroCustoList={centroCustoList}
            despesa={despesa}
            setDespesa={setDespesa}
            despesaList={despesaList}
            contaContabil={contaContabil}
            setContaContabil={setContaContabil}
            isentoIcms={isentoIcms}
            setIsentoIcms={setIsentoIcms}
            aceitaDevolucao={aceitaDevolucao}
            setAceitaDevolucao={setAceitaDevolucao}
            fabricante={fabricante}
            setFabricante={setFabricante}
            frete={frete}
            setFrete={setFrete}
          />

          {showGrid ? (
            <>
              <Box
                sx={{
                  width: "100%",
                  display: "grid",
                }}
              >
                <CustomDatagrid
                  head={head}
                  row={rows}
                  totals={totals}
                  loading={loading}
                  // showEye={data?.contemPecas}
                  // onEyeClick={() => openModalList()}
                  hasTotal={true}
                  // onEyeClick={(row) => console.log("ver", row)}
                  onEditClick={(row) => handleEdit(row)}
                  columnOverrides={{
                    id: { minWidth: 150, maxWidth: 250 },
                    name: { minWidth: 200 },
                    nomeFantasia: { minWidth: 160 },
                    localizacao: { minWidth: 160 },
                    telefone1: { minWidth: 160 },
                    email: { minWidth: 200 },
                  }}
                  onDeleteClick={(row) => handleDelete(row)}
                />
                {totalPages > 1 && (
                  <Pagination
                    page={page}
                    count={totalPages}
                    showFirstButton
                    showLastButton
                    sx={{
                      mt: 1,
                      "& .MuiPaginationItem-root.Mui-selected": {
                        background: Colors.mainLayoutAtiveBackground,
                        color: "black",
                      },
                    }}
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        component={Link}
                        to={`/contas-a-pagar/fornecedor${
                          item.page
                            ? `?page=${item.page}${filter ? `&filtro=${filter}` : ""}`
                            : ""
                        }`}
                      />
                    )}
                  />
                )}
              </Box>
            </>
          ) : null}
          {loading ? (
            <Box
              width={"100%"}
              height={"45vh"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid
                item
                xs={12}
                md={12}
                textAlign={"center"}
                justifyContent={"center"}
                alignItems={"center"}
                bgcolor={"#cadccaff"}
                borderRadius={5}
                padding={5}
                color={Colors.noResultFont}
              >
                <div display={"flex"} style={{ marginTop: "-0.5rem" }}>
                  <CircularProgress color="success" />
                </div>
                <div display={"flex"}>
                  <p
                    style={{
                      color: "#4b4b4b",
                      fontSize: 14,
                      marginBottom: "-1rem",
                    }}
                  >
                    {titleLoading}
                  </p>
                </div>
              </Grid>
            </Box>
          ) : null}
          {notFound ? (
            <Box
              width={"100%"}
              height={"45vh"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid
                size={{ xs: 12, md: 12 }}
                height={{ md: "20%", xs: "50%" }}
                display={"inline-flex"}
                textAlign={"center"}
                justifyContent={"center"}
                alignItems={"center"}
                bgcolor={"lightyellow"}
                borderRadius={5}
                padding={5}
                color={Colors.noResultFont}
              >
                <p
                  style={{
                    color: "#4b4b4b",
                    fontSize: 14,
                  }}
                >
                  Sua pesquisa não retornou nenhum resultado.
                </p>
              </Grid>
            </Box>
          ) : null}
          <ErrorModal
            open={openPayloadModal}
            onClose={() => setOpenPayloadModal(false)}
            errors={payloadErrors}
          />
          <ConfirmModal
            open={openConfirmModal}
            onClose={() => setOpenConfirmModal(false)}
            onConfirm={handleConfirmSave}
            title="Salvar Fornecedor"
            message="Deseja realmente salvar o fornecedor?"
          />
          <ConfirmModal
            open={openBackModal}
            onClose={() => setOpenBackModal(false)}
            onConfirm={confirmBack}
            title="Cancelar"
            message="Deseja realmente cancelar? As alterações não salvas serão perdidas."
          />
          <ConfirmModal
            open={openMessageModal}
            onClose={() => setOpenMessageModal(false)}
            onConfirm={handleConfirmDelete}
            title="Salvar Fornecedor"
            message={messageModal}
          />
        </Box>
      </Box>
    </>
  );
};

const styles = StyleSheet.create({
  pageTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#4b4b4b",
    fontSize: 14,
    margin: 0,
  },
  head: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 1.5,
  },

  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    textAlign: "center",
    textDecoration: "none",
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 4,
    marginTop: "-0.5rem",
    cursor: "pointer",

    padding: "5px 8px 3px 8px",
    transitionDuration: "0.2s",

    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
  },
  topBtn: {
    backgroundColor: "#669966",
    cursor: "pointer",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: "4px 8px",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
    "@media (max-width: 375px)": {
      fontSize: 10,
      padding: "0.3rem 0.5rem",
    },
  },
});
